(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;
		//this.throttledScrollHandler = throttle(this.onScrollHandler, 300);

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		if (document.querySelector('.entering-section')) {
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden');
		}
		else{
			this.header.classList.add('shopify-section-header-sticky', 'animate');
			this.header.classList.remove('shopify-section-header-hidden','color-background-2');
		}
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  /* === Sincronizar tipografía con el nombre de producto === */
  (function(){
    const sample = document.querySelector('.cart-item__name span, .cart-item__name a, .cart-item__name');
    const wrappers = document.querySelectorAll('.sisa-type-sync');
    if(sample && wrappers.length){
      const cs = getComputedStyle(sample);
      wrappers.forEach(function(el){
        el.style.setProperty('--sisa-font-size', cs.fontSize);
        el.style.setProperty('--sisa-line-height', cs.lineHeight);
        el.style.setProperty('--sisa-letter-spacing', cs.letterSpacing);
        el.style.fontWeight = cs.fontWeight || 300;
      });
    }
  })();

  /* === Guardar nota de regalo en atributos (debounce) === */
  (function(){
    const noteEl = document.getElementById('gift-note');
    let t;
    if(!noteEl) return;
    noteEl.addEventListener('input', function(){
      clearTimeout(t);
      t = setTimeout(function(){
        const body = JSON.stringify({ attributes: { 'gift-note': noteEl.value } });
        fetch(`${routes.cart_update_url}`, {
          method:'POST',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body
        }).catch(function(){});
      }, 300);
    });
  })();

  /* === Gift Wrap: quitar anteriores y AÑADIR con /cart/add.js para empujar al final === */
  (function(){
    const wrapBlock = document.getElementById('giftwrap-block');
    if(!wrapBlock) return;

    const gw1 = wrapBlock.getAttribute('data-gw1'); // all together
    const gw2 = wrapBlock.getAttribute('data-gw2'); // each separately
    const radios = wrapBlock.querySelectorAll('input[name="giftwrap_choice"]');
    const noteWrap = document.getElementById('gift-note-wrapper');

    function removeBothThen(action){
      const payload = {};
      if(gw1) payload[gw1] = 0;
      if(gw2) payload[gw2] = 0;
      const body = JSON.stringify({ updates: payload });
      return fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body
      }).then(function(){ if(action) return action(); })
        .catch(function(){ if(action) return action(); });
    }

    function addVariant(variantId){
      if(!variantId) return Promise.resolve();
      const body = JSON.stringify({ id: Number(variantId), quantity: 1 });
      return fetch('/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body
      });
    }

    function setAttributes(attrs){
      const body = JSON.stringify({ attributes: attrs });
      return fetch('/cart/update.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body
      });
    }

    function choose(choice){
      if(choice === 'together' && gw1){
        removeBothThen(function(){
          return addVariant(gw1).then(function(){
            return setAttributes({'gift-wrapping':'true','gift-wrapping-2':''});
          });
        }).finally(function(){ location.reload(); });
      }else if(choice === 'separately' && gw2){
        removeBothThen(function(){
          return addVariant(gw2).then(function(){
            return setAttributes({'gift-wrapping':'','gift-wrapping-2':'true'});
          });
        }).finally(function(){ location.reload(); });
      }else{
        removeBothThen(function(){
          return setAttributes({'gift-wrapping':'','gift-wrapping-2':''});
        }).finally(function(){ location.reload(); });
      }
    }

    radios.forEach(function(r){
      r.addEventListener('change', function(){
        if(this.value === 'none'){
          if(noteWrap) noteWrap.style.display='none';
        } else {
          if(noteWrap) noteWrap.style.display='';
        }
        choose(this.value);
      });
    });
  })();

  /* === Alinear encabezado + nota con la columna de productos (medición real) === */
  (function(){
    function alignCartHead(){
      var media = document.querySelector('.cart-item__media');
      var head = document.querySelector('.cart-head');
      var note = document.querySelector('.cart-shipping-note');
      if(!media || !head) return;
      var mediaW = media.getBoundingClientRect().width || 0;
      var row = media.closest('.cart-item__row') || media.parentElement;
      var gap = 0;
      try { gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap || 0) || 0; } catch(e){}
      var offset = Math.round(mediaW + gap);
      head.style.paddingLeft = offset + 'px';
      if(note) note.style.paddingLeft = offset + 'px';
    }
    document.addEventListener('DOMContentLoaded', alignCartHead);
    window.addEventListener('resize', function(){ requestAnimationFrame(alignCartHead); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
class ProductModal extends ModalDialog {
	constructor() {
		super();

		this.isProductPage = true
	}

	hide() {
		super.hide(this.isProductPage);
		window.pauseAllMedia();
	}

	show(opener) {
		super.show(opener);
		this.showActiveMedia();		
	}

	showActiveMedia() {
		const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
		if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
		}
		if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube'))
			activeMedia.loadContent();
	}
}

customElements.define('product-modal', ProductModal);


  } catch(e) { console.error(e); }
})();
})();
